import { Trans, useTranslation } from 'next-i18next'
import styled, { css } from 'styled-components'

import { useDateTime } from '../../../hooks'
import { NookEvent } from '../../../types'
import { forScreensGreaterThanMobileWidth } from '../../../utils'
import { EventAlert } from '../../EventAlert'
import { Content as RepeatEventSummaryContent } from '../RepeatEventSummary'

const PaidEventSummaryLayout = styled(EventAlert)`
  ${forScreensGreaterThanMobileWidth(css`
    width: calc(50vw - 40px - 60px - 50px);
  `)}
`
const AttendingOneEvent: React.FC<{ event: Partial<NookEvent> }> = ({
  event,
}) => {
  const { t } = useTranslation('common')

  const { title, start_date } = event

  const dateTime = useDateTime(start_date)

  return (
    <PaidEventSummaryLayout
      title={t(
        'You are attending ONE event in this series.',
        'You are attending ONE event in this series.',
      )}
      details={
        <Trans i18nKey="hero-20220415171017078809669">
          Your upcoming event, <strong>{{ title }}</strong>, is on{' '}
          <strong>{{ dateTime }}</strong>. To sign up to the entire series
          update your attendance.
        </Trans>
      }
    />
  )
}

const AttendingAllEvent: React.FC<{ event: Partial<NookEvent> }> = ({
  event,
}) => {
  const { t } = useTranslation('common')

  return (
    <PaidEventSummaryLayout
      title={t(
        'You are attending ALL events in this series.',
        'You are attending ALL events in this series.',
      )}
      details={
        <Trans i18nKey="hero-20220415173444044410976">
          Repeats <RepeatEventSummaryContent event={event} />. You will be
          automatically charged 24hs before each event from the series.{' '}
        </Trans>
      }
    />
  )
}

function getTypeOfEvent(event: Partial<NookEvent>): 'all' | 'one' {
  return 'all'
}

export const PaidEventSummary: React.FC<{ event: Partial<NookEvent> }> = ({
  event,
}) => {
  const { is_recurring, is_user_going } = event
  if (!is_recurring || !is_user_going) {
    return null
  }

  const type = getTypeOfEvent(event)
  if (type === 'all') {
    return <AttendingAllEvent event={event} />
  }
  if (type === 'one') {
    return <AttendingOneEvent event={event} />
  }
  return null
}
